var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg32IconEyeOpened(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fffefa",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-382.245 -2715.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.415,77.147a10.838,10.838,0,0,1-9.459-5.636,10.755,10.755,0,0,1,18.918,0A10.838,10.838,0,0,1,11.415,77.147Z",
    transform: "translate(386.829 2660.169)",
    fill: "none",
    stroke: "#816920",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.312,6.625A3.315,3.315,0,0,1,.088,2.55a1.405,1.405,0,0,0,.858.289A1.42,1.42,0,0,0,1.861.334,3.28,3.28,0,0,1,3.312,0a3.312,3.312,0,0,1,0,6.625Z",
    transform: "translate(394.936 2728.41)",
    fill: "#816920"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32IconEyeOpened);
export default __webpack_public_path__ + "static/media/32-icon-eye-opened.5dad0312.svg";
export { ForwardRef as ReactComponent };